import { V3Models } from "@istari/istari-client";

import { UpstreamRemote } from "~/resource/model/upstream-remote";

// Narrow to the fields consumed here so both the v3 `UpstreamRemoteInfoDto`
// and the v2 `UpstreamRemoteInfo` (which lacks `upstreamFileId`) can flow
// through this adapter, while keeping the compile-time link to the SDK shape.
export function toUpstreamRemote(dto: Pick<V3Models.UpstreamRemoteInfoDto, "id" | "label">): UpstreamRemote {
  return {
    id: dto.id,
    label: dto.label,
  };
}
